import type { stacks } from "@dropbox/api-v2-client";
import { IconButton } from "@dropbox/dig-components/buttons";
import { Popover } from "@dropbox/dig-components/popover";
import { UIIcon } from "@dropbox/dig-icons";
import { DeleteLine, EditLine } from "@dropbox/dig-icons/dist/mjs/assets";
import { DigTooltip } from "@mirage/shared/util/DigTooltip";
import i18n from "@mirage/translations";
import { useState } from "react";
import { AddItemButtonAugRev } from "./AddItemButton";
import styles from "./HeaderPopover.module.css";
import { useContentSuggestions } from "./hooks";

export const HeaderPopover = ({
  isOpen,
  anchorRef,
  onEdit,
  onDelete,
  onAdd,
  section,
  offsetDistance = 10,
}: {
  isOpen: boolean;
  anchorRef: React.RefObject<HTMLElement>;
  onEdit: () => void;
  onDelete: () => void;
  onAdd: () => void;
  section: stacks.Section;
  offsetDistance?: number;
}) => {
  const [isPopoverHovering, setIsPopoverHovering] = useState(false);
  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsPopoverHovering(false);
    }, 200);
  };
  const { contentSuggestions, isFetchingContentSuggestions } =
    useContentSuggestions();

  return (
    <Popover
      open={isOpen || isPopoverHovering}
      onToggle={setIsPopoverHovering}
      closeOnOutsideClick
      anchorEl={anchorRef.current}
      placement="top-start"
      paddingX={0}
      paddingY={0}
      triggerStrategy="hover"
      offsetDistance={offsetDistance}
    >
      <Popover.Overlay>
        <Popover.Content asChild>
          <div
            className={styles.popoverContent}
            onMouseEnter={() => setIsPopoverHovering(true)}
            onMouseLeave={handleMouseLeave}
          >
            <DigTooltip title={i18n.t("add_section_item")} placement="top">
              <IconButton variant="outline" onClick={onAdd}>
                <AddItemButtonAugRev
                  contentSuggestions={contentSuggestions}
                  loadingSuggestions={isFetchingContentSuggestions}
                  section={section}
                  variant="icon"
                  emphasize
                />
              </IconButton>
            </DigTooltip>
            <DigTooltip title={i18n.t("rename_section")} placement="top">
              <IconButton variant="outline" onClick={onEdit}>
                <UIIcon src={EditLine} />
              </IconButton>
            </DigTooltip>
            <DigTooltip title={i18n.t("remove_section")} placement="top">
              <IconButton variant="outline" onClick={onDelete}>
                <UIIcon src={DeleteLine} />
              </IconButton>
            </DigTooltip>
          </div>
        </Popover.Content>
      </Popover.Overlay>
    </Popover>
  );
};
